import React, { useState, useEffect } from 'react'
import Proptypes from 'prop-types'
import { Modal, Button } from 'semantic-ui-react'
import { DataGrid } from '@mui/x-data-grid'
import { primaryColor } from '../../../../constants'
import SiteActionsModal from './siteActionsModal'
import './viewSitesModal.css'

// import styles from './customerHierarchy.module.css'

const columns = [
  { field: 'name', headerName: 'Name', width: 203 },
  { field: 'id', headerName: 'ID', width: 203 },
]

const ViewSitesModal = (props) => {
  const [open, setOpen] = useState(false)
  const [actionsOpen, setActionsOpen] = useState(false)
  const [level, setSelectedLevel] = useState({})
  useEffect(() => {
    setOpen(props.open)
  }, [props.open])

  useEffect(() => {
    props.getOpenState(open)
  }, [open])

  const handleCellClick = async (e) => {
    const productName = await localStorage.getItem('product')
    if (productName === 'tank') {
      setSelectedLevel({
        customerId: props.customerId,
        id: e.id,
        label: e.row.name,
        levelType: 'level3',
      })
      setActionsOpen(true)
    }
  }

  const renderSites = () => {
    if (props.sites.length === 0)
      return <b style={{ fontSize: '18px' }}>No Items Found</b>

    const newSites = props.sites.map((site) => ({
      name: site.label ? site.label : 'N/A',
      id: site.name ? site.name : 'N/A',
    }))
    return (
      <div style={{ height: 400, width: '100%' }}>
        <DataGrid
          onCellClick={(e) => handleCellClick(e)}
          rows={newSites}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
        />
      </div>
    )
  }

  const getActionModalState = (openState) => setActionsOpen(openState)

  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        style={{ width: '450px' }}
      >
        <Modal.Header style={{ backgroundColor: '#303D54', color: '#FFF' }}>
          Level 3: Items
        </Modal.Header>
        <Modal.Content>{renderSites()}</Modal.Content>
        <Modal.Actions>
          <Button
            style={{ backgroundColor: primaryColor, color: 'white' }}
            onClick={() => setOpen(false)}
          >
            Close
          </Button>
        </Modal.Actions>
      </Modal>

      <SiteActionsModal
        open={actionsOpen}
        level={level}
        getState={getActionModalState}
      />
    </>
  )
}

ViewSitesModal.propTypes = {
  open: Proptypes.bool,
  getOpenState: Proptypes.func,
  sites: Proptypes.array,
  customerId: Proptypes.string,
}

export default ViewSitesModal
